module.exports = __webpack_public_path__ + "img/equipo-de-trabajo-ofis.19d96eab.jpg";